<template>
  <header class="header">
    <nav class="header__container">
      <span
        :class="{
          'header__logo--active': home
        }"
        class="header__logo">
        <router-link to="/">{{ logo }}</router-link> 
      </span>

      <ul class="header__menu">
        <li
          :class="{
            'header__item--active': !home
          }"
          class="header__item">
          <router-link to="/what-is-wilks">What is Wilks?</router-link> 
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'v-header',
  data () {
    return {
      logo: 'Wilks Score'
    }
  },
  computed: {
    home () {
      return this.$route.name === 'Overview'
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
  &__container{
    @include vw-size('padding-top', 37, 0, 1);
    @extend %container;
  }
  &__logo{
    font-size:14px;
    border-radius:2px;
    padding: 3px 5px;
    border: 1px solid white;
    text-transform:uppercase;
    line-height:1;
    font-family: $ff-source;
    font-weight:900;
    font-style:italic;
    display: inline-block;
    float:left;
    background-color: rgba(0,0,0,0.3);
    transition: all 200ms ease-in-out;
    opacity: 0.25;

    &:hover{
      background-color:rgba(0,0,0,0.5);
      opacity: .75;
    }

    &--active{
      opacity: 1;
    }
  }
  &__menu{
    display:inline-block;
    float:right;
    list-style-type:none;
    padding:0;
    margin:0;
    text-align: right;
    font-size:0;
  }
  &__item{
    display:inline-block;
    font-size:0;
    font-family: $ff-source;
    font-weight:400;
    vertical-align: top;
    position:relative;
    transition: all 200ms ease-in-out;

    &:after{
      content:"";
      position:absolute;
      bottom:-2px;
      left:0;
      right:0;
      border-bottom:1px solid $c-lightblue;
      opacity: 0;
      transform:translateY(-2px);
      transition:all 200ms ease-in-out;
    }

    &--active, &:hover{
      &:after{
        transform:translateY(0px);
        opacity: 1;
      }
    }

    a {
      font-size:14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Vheader.vue